import Component from './component.vue';
import Mixin from './script';

export * from './types';
export { Mixin };
export default Component;



// WEBPACK FOOTER //
// ./src/components/calendar/month/index.ts